import axios from "axios";
import React from "react";
import { Spinner } from "react-rainbow-components";
import { ModalProps } from "react-rainbow-components/components/Modal";
import { GetErrorMessage } from "../../functions/error";
import { IUser } from "../../interfaces/user";
import { getAllUser } from "../../services/user.service";
import { useError } from "../../store/ErrorModal";
import { InputAdmin, Title } from "../common/FormComponent";
import { ProfileComponent } from "../common/ProfileComponent";
import {
  CardUser,
  Container,
  ContainerHeader,
  MyModal,
  SelectButton,
  TextSelect,
  UserCountaints,
} from "./ModalAddUserCodeCoupon.style";

interface Props {
  users?: IUser[];
  codeFocus?: string;
  fetchData?: () => void;
}
const ModalAddUserCodeCoupon = (props: Props & ModalProps) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [users, setUsers] = React.useState<IUser[]>(props.users || []);
  const [userShow, setUserShow] = React.useState<IUser[]>(props.users || []);
  const [searchKey, setSearchKey] = React.useState<string>("");
  const { onError } = useError();
  const fetchData = React.useCallback(async () => {
    if (!users) {
      setIsLoading(true);
      try {
        const user = await getAllUser();
        setUsers(user.data);
        setUserShow(user.data);
      } catch (error) {
        onError(GetErrorMessage(error));
      }
      setIsLoading(false);
    }
  }, [users, onError]);
  React.useEffect(() => {
    fetchData();
  }, [fetchData]);
  React.useEffect(() => {
    if (!users || users.length === 0) return;
    const nUsers = users.filter((item) => {
      if (
        !item.firstName ||
        !item.lastName ||
        !item.displayName ||
        !item.phone ||
        !item.email ||
        item.petsName === undefined
      )
        return false;
      return (
        item.firstName.includes(searchKey) ||
        item.lastName.includes(searchKey) ||
        item.displayName.includes(searchKey) ||
        item.phone.includes(searchKey) ||
        item.email.includes(searchKey) ||
        item.petsName.includes(searchKey)
      );
    });
    setUserShow(nUsers);
  }, [searchKey, users]);

  const hadleSelect = async (uid: string) => {
    setIsLoading(true);
    if (!props.codeFocus) return;
    try {
      await axios.post("/coupon/useCoupon", {
        uid,
        codeCoupon: props.codeFocus,
      });
      props.onRequestClose && props.onRequestClose();
      props.fetchData && props.fetchData();
    } catch (error) {
      onError(GetErrorMessage(error));
    }
    setIsLoading(false);
  };
  return (
    <MyModal
      {...props}
      hideCloseButton
      title={
        !isLoading && (
          <ContainerHeader>
            <Title>เลือกผู้ใช้</Title>
            <InputAdmin
              placeholder="ค้นหา"
              onChange={(e) => setSearchKey(e.target.value)}
            />
          </ContainerHeader>
        )
      }
    >
      {isLoading ? (
        <Spinner />
      ) : (
        <Container>
          <UserCountaints>
            {userShow &&
              userShow.map((item) => {
                return (
                  <CardUser key={item.uid}>
                    <ProfileComponent
                      name={`${item.firstName} ${item.lastName}`}
                      avatar={item.imageUrl || ""}
                      lineId={item.petsName && `สัตว์เลี้ยง: ${item.petsName}`}
                    />
                    <SelectButton onClick={() => hadleSelect(item.uid)}>
                      +<TextSelect>เลือก</TextSelect>
                    </SelectButton>
                  </CardUser>
                );
              })}
          </UserCountaints>
        </Container>
      )}
    </MyModal>
  );
};

export default ModalAddUserCodeCoupon;
